<template>
    <div class="customers-info-section">
        <div class="row">
            <div class="col-md-3 col-sm-12 text-center profile-image-section">
                <div v-if="customerDetails.pictureURL" class="customer-profile">
                    <img v-authenticated-image="customerDetails.pictureURL" />
                </div>

                <base-status
                    v-if="customerDetails.status"
                    :status-type="customerDetails.status"
                ></base-status>
            </div>
            <div class="col-md-9 col-sm-12">
                <ul>
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Customer Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Idenfo ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.idenfoId
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <!-- <div class="col-md-6">
                    <ul class="row">
                        <li class="col-md-6">
                            <label>Bank Customer ID:</label>
                        </li>
                        <li class="col-md-6">
                            <span class="">{{
                                customerDetails.bankCustomerId
                                    ? customerDetails.bankCustomerId
                                    : 'N/A'
                            }}</span>
                        </li>
                    </ul>
                </div> -->
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Full Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.firstName
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Father’s/Husband’s Name:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.fatherOrHusbandName
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Mother’s Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.motherName
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Gender:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.gender
                                                    ? customerDetails.gender
                                                          .title
                                                    : ''
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Date of Birth:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.dateOfBirth
                                                "
                                                >{{
                                                    customerDetails.dateOfBirth
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Religion:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.religion
                                                    ? customerDetails.religion
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Marital Status:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.maritalStatus
                                                    ? customerDetails.maritalStatus
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Bank Status:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.apiHitSuccess
                                                    ? capitalizeField(
                                                          customerDetails.apiHitSuccess
                                                      )
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Zakat Deduction:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.zakat &&  customerDetails.zakat.length
                                                    ? customerDetails.zakat[0]
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="!isSSAAccount" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Minor Account:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.isMinorAccount
                                                    ? customerDetails.isMinorAccount
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Record Last Updated:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="customerDetails.updatedAt"
                                                >{{
                                                    customerDetails.updatedAt
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- RESIDENTIAL INFO -->
                <ul v-if="customerDetails.contactInfo && !isSSAAccount">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Residential Information</h3>
                                </div>
                                <div
                                    v-for="(item, index) in residentialInfo"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

                <!-- CONTACT INFO -->
                <ul v-if="customerDetails.contactInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Contact Information</h3>
                                </div>
                                <div
                                    v-for="(item, index) in contactInformation"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Nationality:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails.nationalityIsSanction,
                                                }"
                                                >{{
                                                    customerDetails.nationality
                                                        ? customerDetails
                                                              .nationality.title
                                                        : ''
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <!-- <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Do you have other
                                                Nationalities:</label
                                            >
                                        </li>

                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.hasOtherNationalities
                                                    ? customerDetails.hasOtherNationalities
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Specify other
                                                Nationalities:</label
                                            >
                                        </li>

                                        <li class="col-md-6">
                                            <span
                                                v-for="(
                                                    nationality, index
                                                ) in customerDetails.otherNationalities"
                                                :key="index"
                                            >
                                                {{ nationality.title ? nationality.title : 'N/A' }}
                                                <br />
                                            </span>
                                        </li>
                                    </ul>
                                </div> -->
                            </div>
                        </div>
                    </li>
                </ul>

                <!-- Tax Details -->
                <ul v-if="customerDetails.occupationInfo && !isSSAAccount">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Tax Information</h3>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >National Tax No. (NTN):</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo.taxNo
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo.taxNo
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Tax Status:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="customerDetails.taxStatus"
                                                class=""
                                                >{{
                                                    customerDetails.taxStatus
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

                <!-- minor account Details -->
                <ul v-if="customerDetails.accountInfo && !isSSAAccount">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>
                                        Minor Account Information (Optional)
                                    </h3>
                                </div>
                                <div
                                    v-for="(data, index) in minorAccountDetails"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ data.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                data.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

                <!-- bank details -->
                <ul v-if="customerDetails.accountInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Bank Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Bank Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .bankName
                                                    ? capitalizeField(
                                                          customerDetails
                                                              .accountInfo
                                                              .bankName
                                                      )
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Branch:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .bankBranch
                                                    ? customerDetails
                                                          .accountInfo
                                                          .bankBranch
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Bank Account Title:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .bankTitle
                                                    ? customerDetails
                                                          .accountInfo.bankTitle
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Branch Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .bankAddress
                                                    ? customerDetails
                                                          .accountInfo
                                                          .bankAddress
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-8">
                                    <ul class="row">
                                        <li class="col-md-4">
                                            <label>IBAN/Account No.:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .bankAccountNo
                                                    ? customerDetails
                                                          .accountInfo
                                                          .bankAccountNo
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- professional info -->
                <ul v-if="customerDetails.occupationInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Professional Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Education:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.occupationInfo
                                                    .education
                                                    ? customerDetails
                                                          .occupationInfo
                                                          .education
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Industry:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo.industry
                                                        .length
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo
                                                        .industry[0].title
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Occupation:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo
                                                        .occupation
                                                "
                                                class=""
                                                >{{
                                                    capitalizeField(
                                                        customerDetails
                                                            .occupationInfo
                                                            .occupation
                                                    )
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Source of Funds:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo
                                                        .sourceOfFunds
                                                "
                                                class=""
                                                >{{
                                                    capitalizeField(
                                                        customerDetails
                                                            .occupationInfo
                                                            .sourceOfFunds
                                                    )
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Monthly Income:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.accountInfo
                                                        .monthlyIncome
                                                "
                                                class=""
                                                >{{
                                                    customerDetails.accountInfo
                                                        .monthlyIncome
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>

                                <div v-if="!isSSAAccount" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Purpose and intended nature of
                                                business relationship:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.accountInfo
                                                        .natureBusinessRelation
                                                "
                                                class=""
                                                >{{
                                                    customerDetails.accountInfo.natureBusinessRelation.join(
                                                        ', '
                                                    )
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="!isSSAAccount" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Geographies involved
                                                (Domestic):</label
                                            >
                                        </li>

                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo
                                                        .geographies
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo
                                                        .geographies
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <!-- counter parties -->
                                <!-- <div v-if="!isSSAAccount" class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label
                                                        >Type of Counter Parties
                                                        (Domestic):</label
                                                    >
                                                </li>
                                                <li class="col-md-6">
                                                    <span
                                                        v-if="
                                                            customerDetails
                                                                .occupationInfo
                                                                .counterParties &&
                                                            customerDetails
                                                                .occupationInfo
                                                                .counterParties
                                                                .length
                                                        "
                                                        class=""
                                                        >{{
                                                            customerDetails
                                                                .occupationInfo
                                                                .counterParties.join(', ')
                                                        }}</span
                                                    >
                                                    <span v-else>N/A</span>
                                               
                                            </ul>
                                        </div> -->

                                <div v-if="!isSSAAccount" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Possible modes of transcations
                                                / Delivery Channels:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.accountInfo
                                                        .deliveryChannels && customerDetails.accountInfo
                                                        .deliveryChannels.length
                                                "
                                                class=""
                                                >{{
                                                    customerDetails.accountInfo
                                                        .deliveryChannels[0]
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- identity info -->
                <ul v-if="customerDetails.identityInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>ID Document</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Document Type:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .type | identityInfoType
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>ID Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .number
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Expiry Date:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.identityInfo
                                                        .expiryDate
                                                "
                                                :class="
                                                    addDangerClass(
                                                        customerDetails
                                                            .identityInfo
                                                            .expiryDate
                                                    )
                                                "
                                                >{{
                                                    customerDetails.identityInfo
                                                        .expiryDate
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                            <span v-else>Lifetime Expiry</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Issuance Date:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .IssuanceDate
                                                    | moment('MMM D, YYYY')
                                            }}</span>
                                            <!-- <span class="">{{
                          customerDetails.identityInfo
                              .IssuanceDate
                              ? customerDetails
                                    .identityInfo
                                    .IssuanceDate
                              : 'N/A'
                      }}</span> -->
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Life Time Expiry:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="
                                                    addDangerClass(
                                                        customerDetails
                                                            .identityInfo
                                                            .isLifetimeExpiry
                                                            ? customerDetails
                                                                  .identityInfo
                                                                  .isLifetimeExpiry[0]
                                                            : 'N/A'
                                                    )
                                                "
                                                >{{
                                                    customerDetails.identityInfo
                                                        .isLifetimeExpiry &&
                                                    customerDetails.identityInfo
                                                        .isLifetimeExpiry.length
                                                        ? customerDetails
                                                              .identityInfo
                                                              .isLifetimeExpiry[0]
                                                        : 'N/A'
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- account manangemenet info -->
                <ul v-if="customerDetails.accountInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Account Management Instructions</h3>
                                </div>
                                <div
                                    v-for="(
                                        item, index
                                    ) in accountManagementInstructions"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- kyc/pep -->
                <ul v-if="customerDetails.accountInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div v-if="isSSAAccount" class="col-md-12">
                                    <h3>KYC Questionnaire / PEP Declaration</h3>
                                </div>
                                <div v-else class="col-md-12">
                                    <h3>PEP Declaration</h3>
                                </div>
                                <div
                                    v-for="(item, index) in pepDeclaration"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- nominee details -->
                <ul v-if="customerDetails.accountInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Nominee Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Name (Mr./Ms./Mrs.):</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .nomineeName1
                                                    ? customerDetails
                                                          .accountInfo
                                                          .nomineeName1
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Father's/Husband's Name:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .nomineeFatherName1
                                                    ? customerDetails
                                                          .accountInfo
                                                          .nomineeFatherName1
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <!-- <div class="col-md-6">
                    <ul class="row">
                        <li class="col-md-6">
                            <label
                                >Mother's Name:</label
                            >
                        </li>
                        <li class="col-md-6">
                            <span class="">{{
                                customerDetails
                                    .accountInfo
                                    .nomineeMotherName1
                                    ? customerDetails
                                          .accountInfo
                                          .nomineeMotherName1
                                    : 'N/A'
                            }}</span>
                        </li>
                    </ul>
                </div> -->
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>CNIC/NICOP No.:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .nomineeCNIC1
                                                    ? customerDetails
                                                          .accountInfo
                                                          .nomineeCNIC1
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <!-- <div class="col-md-6">
                    <ul class="row">
                        <li class="col-md-6">
                            <label
                                >ID Issuance Date:</label
                            >
                        </li>
                        <li class="col-md-6">
                            <span class="">{{
                                customerDetails
                                    .accountInfo
                                    .nomineeIssuanceDate1
                                    ? customerDetails
                                          .accountInfo
                                          .nomineeIssuanceDate1
                                    : 'N/A'
                            }}</span>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6">
                    <ul class="row">
                        <li class="col-md-6">
                            <label>ID Expiry Date:</label>
                        </li>
                        <li class="col-md-6">
                            <span class="">{{
                                customerDetails
                                    .accountInfo
                                    .nomineeExpiryDate1
                                    ? customerDetails
                                          .accountInfo
                                          .nomineeExpiryDate1
                                    : 'N/A'
                            }}</span>
                        </li>
                    </ul>
                </div>
              
                 
               
               -->
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Email Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .nomineeEmail1
                                                    ? customerDetails
                                                          .accountInfo
                                                          .nomineeEmail1
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Mailing Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .nomineeAddress1
                                                    ? customerDetails
                                                          .accountInfo
                                                          .nomineeAddress1
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Phone Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .nomineePhone1
                                                    ? customerDetails
                                                          .accountInfo
                                                          .nomineePhone1
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Relationship:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .nomineeRelationship1
                                                    ? customerDetails
                                                          .accountInfo
                                                          .nomineeRelationship1
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- joint account holder details -->
                <ul v-if="customerDetails.accountInfo && !isSSAAccount">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>
                                        Joint Account Holder Details (Optional)
                                    </h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Name (Mr./Ms./Mrs.):</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .jointAHName
                                                    ? customerDetails
                                                          .accountInfo
                                                          .jointAHName
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Father's/Husband's Name:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .jointAHFatherOrHusbandName
                                                    ? customerDetails
                                                          .accountInfo
                                                          .jointAHFatherOrHusbandName
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>CNIC/NICOP No.:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .jointAHCNIC
                                                    ? customerDetails
                                                          .accountInfo
                                                          .jointAHCNIC
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Mailing Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .jointAHAddress
                                                    ? customerDetails
                                                          .accountInfo
                                                          .jointAHAddress
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- transaction details -->
                <ul v-if="customerDetails.accountInfo && !isSSAAccount">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Transaction Information</h3>
                                </div>
                                <div
                                    v-for="(item, index) in transactionDetails"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- fatca details -->
                <ul v-if="customerDetails.accountInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>FATCA Information</h3>
                                </div>
                                <div
                                    v-for="(item, index) in factaDetails"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- w-9 info -->
                <ul v-if="customerDetails.w9Info">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>W-9 Form (For US Citizens)</h3>
                                </div>
                                <div
                                    v-for="(item, index) in w9Info"
                                    :key="index"
                                    class="col-md-4"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-4">
                                            <label>Account Number:</label>
                                        </li>
                                        <li class="col-md-8">
                                            <span class="">{{
                                                customerDetails.w9Info
                                                    .accountNumber
                                                    ? customerDetails.w9Info
                                                          .accountNumber
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- crs info -->
                <ul v-if="customerDetails.crsInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>CRS Form Information</h3>
                                </div>
                                <div
                                    v-for="(item, index) in crsDetails"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- declaration by customer -->
                <ul v-if="customerDetails.accountInfo && !isSSAAccount">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Declaration By Customer</h3>
                                </div>
                                <div
                                    v-for="(
                                        item, index
                                    ) in declarationByCustomer"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- ultimate beneficiary -->
                <!-- <ul v-if="customerDetails.accountInfo && !isSSAAccount">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>
                                        Ultimate Beneficiary (if applicable)
                                    </h3>
                                </div>
                                <div
                                    v-for="(item, index) in ultimateBenefit"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->

                <!-- investment -->
                <ul v-if="customerDetails.investmentRisk">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Investment</h3>
                                </div>
                                <div
                                    v-for="(item, index) in customerDetails
                                        .investmentRisk.selectOptions"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.quesTitle }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.optionTitle
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- pmd info -->
                <ul v-if="customerDetails.pmd && !isSSAAccount">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>PMD Verification</h3>
                                </div>
                                <div
                                    v-for="(item, index) in pmd"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ item.field }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                item.value
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

                <!-- risk profiling -->
                <ul v-if="customerDetails.investmentRisk">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Risk Profiling</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Selected Risk:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.investmentRisk
                                                    .tolerance
                                                    ? customerDetails
                                                          .investmentRisk
                                                          .tolerance
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Score:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.investmentRisk
                                                    .score
                                                    ? customerDetails
                                                          .investmentRisk.score
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Recommended Risk:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.investmentRisk
                                                    .recommendedRisk
                                                    ? customerDetails
                                                          .investmentRisk
                                                          .recommendedRisk
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Disclaimer:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="color-red">{{
                                                customerDetails.investmentRisk
                                                    .disclaimer
                                                    ? customerDetails
                                                          .investmentRisk
                                                          .disclaimer
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-12">
                                    <ul class="row">
                                        <li class="col-md-3">
                                            <label>Fund Risk Category:</label>
                                        </li>
                                        <li class="col-md-9">
                                            <span>{{
                                                customerDetails.investmentRisk
                                                    .secpProduct
                                                    ? customerDetails
                                                          .investmentRisk
                                                          .secpProduct
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-12">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Recommended Fund(s) as per Fund
                                                Risk Category:</label
                                            >
                                        </li>
                                    </ul>
                                </div>

                                <div
                                    v-for="(item, index) in customerDetails
                                        .investmentRisk.riskProduct"
                                    :key="index"
                                    class="col-lg-12 mb-2"
                                >
                                    <div class="product-tags-section">
                                        <div class="product-tags">
                                            <label class="font-size-13">{{
                                                item
                                            }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.diligenceStatus">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>On-Going Due Diligence</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Last Review:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                "
                                                >{{
                                                    customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    !customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                "
                                                >N/A</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Next Review:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="danger">{{
                                                customerDetails.diligenceStatus
                                                    .nextReview
                                                    | moment('MMM D, YYYY')
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Expiry Date:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="
                                                    addDangerClass(
                                                        customerDetails
                                                            .diligenceStatus
                                                            .expiryDate
                                                    )
                                                "
                                                >{{
                                                    customerDetails
                                                        .diligenceStatus
                                                        .expiryDate
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul
                    v-if="
                        customerDetails.customInfo &&
                        Object.keys(customerDetails.customInfo).length
                    "
                >
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Additional Information</h3>
                                </div>
                                <div
                                    v-for="(
                                        info, index
                                    ) in customerDetails.customInfo"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ info.title }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="info.type == 'text-field'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="info.type == 'text-area'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                    !!info.value
                                                "
                                                >{{
                                                    info.value
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                    !info.value
                                                "
                                                >N/A</span
                                            >
                                            <span
                                                v-if="info.type == 'dropdown'"
                                                >{{ info.value }}</span
                                            >
                                            <span v-if="info.type == 'radio'">{{
                                                info.value
                                            }}</span>
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                    info.value
                                                "
                                                >{{
                                                    info.value.join(', ')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                    !info.value
                                                "
                                            >
                                                N/A
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
export default {
    // End of Component > mounted

    /*
|--------------------------------------------------------------------------
| Component > filters
|--------------------------------------------------------------------------
*/
    filters: {
        identityInfoType: function (value) {
            switch (value) {
                case 'id':
                    return 'National ID Card'

                case 'nicop':
                    return 'National Identity Card for Overseas Pakistanis'

                case 'poc':
                    return 'Pakistan Origin Card'

                case 'arc':
                    return 'National Alien Registration System'

                case 'licence':
                    return 'Driving Licence'

                case 'passport':
                    return 'Passport'
            }
        },
    },
    /*
|--------------------------------------------------------------------------
| Component > props
|--------------------------------------------------------------------------
*/
    props: {
        customerDetails: {
            type: Object,
            default: null,
        },
    }, // End of Component > props

    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/
    data() {
        return {
            declarationByCustomer: [],
            pepDeclaration: [],
            ultimateBenefit: [],
            factaDetails: [],
            crsDetails: [],
            w9Info: [],
            pmd: [],
            transactionDetails: [],
            accountManagementInstructions: [],
            contactInformation: [],
            minorAccountDetails: [],
            residentialInfo: [],
            isSSAAccount: false,
        }
    }, // End of Component > data

    /*
|--------------------------------------------------------------------------
| Component > computed
|--------------------------------------------------------------------------
*/
    computed: {
        ...mapGetters(['loading', 'dataSegmentId']),
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > methods

    /*
|--------------------------------------------------------------------------
| Component > mounted
|--------------------------------------------------------------------------
*/
    mounted() {
        this.checkAccountType()
        this.assigningCustomerDataToFields()
    }, // End of Component > computed

    /*
|--------------------------------------------------------------------------
| Component > methods
|--------------------------------------------------------------------------
*/
    methods: {
        capitalizeField(field) {
            if (/\s/.test(field)) {
                let arr = field.split(' ')
                for (var i = 0; i < arr.length; i++) {
                    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
                }

                let str2 = arr.join(' ')
                return str2
            } else {
                return field.charAt(0).toUpperCase() + field.slice(1)
            }

            // return _.capitalize(field)
        },
        addDangerClass(date) {
            let expiryDate = this.$moment(date)
            let diff = expiryDate.diff(this.$moment(), 'days')
            if (diff <= 60) {
                return 'danger'
            }
            return ''
        },
        checkAccountType() {
            if (this.dataSegmentId == process.env.VUE_APP_RC_ACCOUNT) {
                this.isSSAAccount = false
            } else if (this.dataSegmentId == process.env.VUE_APP_SSA_ACCOUNT) {
                // console.log("SSA ACCOUNT")
                this.isSSAAccount = true
            }
        },
        checkPep(pepDec) {
            if (Array.isArray(pepDec)) {
                return pepDec[0]
            } else if (typeof pepDec == 'string') {
                return pepDec
            }
        },
        assigningCustomerDataToFields() {
            /* below sections common in both type of forms
             */
            this.pepDeclaration.push(
                {
                    field: 'Are you a resident/ national of any country other than Pakistan?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP1
                            ? this.checkPep(
                                  this.customerDetails.pepInfo.declarationPEP1
                              )
                            : 'N/A',
                },
                {
                    field: 'Do you belong to a country that is not part of FATF (Financial Action Task Force*)?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP2
                            ? this.checkPep(
                                  this.customerDetails.pepInfo.declarationPEP2
                              )
                            : 'N/A',
                },
                {
                    field: 'Do you have any business relationship or transactions in/ from offshore tax haven countries?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP3
                            ? this.checkPep(
                                  this.customerDetails.pepInfo.declarationPEP3
                              )
                            : 'N/A',
                },
                {
                    field: 'Has any financial institution ever refused to open your account?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP4
                            ? this.checkPep(
                                  this.customerDetails.pepInfo.declarationPEP4
                              )
                            : 'N/A',
                },
                {
                    field: 'Do you deal in high value items i.e. Gold, silver, diamonds, metals, gems etc.?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP5
                            ? this.checkPep(
                                  this.customerDetails.pepInfo.declarationPEP5
                              )
                            : 'N/A',
                },
                {
                    field: 'Are you a resident or inhabitant of southern punjab or afghan border?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP6
                            ? this.checkPep(
                                  this.customerDetails.pepInfo.declarationPEP6
                              )
                            : 'N/A',
                },
                {
                    field: 'Do you hold a high profile position i.e. sports or media personality?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP7
                            ? this.checkPep(
                                  this.customerDetails.pepInfo.declarationPEP7
                              )
                            : 'N/A',
                },
                {
                    field: 'Are you acting on behalf of any other person? (if yes, please provide "declaration for ultimate beneficial ownership")',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP8
                            ? this.customerDetails.pepInfo.declarationPEP8
                            : 'N/A',
                },

                {
                    field: 'Name of Ultimate Beneficial Ownership',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.nameUBO
                            ? this.customerDetails.pepInfo.nameUBO
                            : 'N/A',
                },
                {
                    field: 'CNIC of Ultimate Beneficial Ownership',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.cnicUBO
                            ? this.customerDetails.pepInfo.cnicUBO
                            : 'N/A',
                },
                {
                    field: 'Are you a domestic or foreign "Politically Exposed Person" (PEP)?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP9
                            ? this.customerDetails.pepInfo.declarationPEP9
                            : 'N/A',
                },

                {
                    field: 'Are you a family member or close associate of a domestic or foreign "Politically Exposed Person" (PEP)?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP10
                            ? this.customerDetails.pepInfo.declarationPEP10
                            : 'N/A',
                }
            )

            this.accountManagementInstructions.push(
                {
                    field: 'Instruction to Operate Account',
                    value:
                        this.customerDetails &&
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.operateAccount
                            ? this.customerDetails.accountInfo.operateAccount
                            : 'N/A',
                },
                {
                    field: 'Dividend Instructions',
                    value:
                        this.customerDetails &&
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.stockDividend &&
                        this.customerDetails.accountInfo.stockDividend.length
                            ? this.customerDetails.accountInfo.stockDividend[0]
                            : 'N/A',
                },
                {
                    field: 'Do you wish to receive Statement of Accounts?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.receiveAccountStatement
                            ? this.customerDetails.accountInfo
                                  .receiveAccountStatement
                            : 'N/A',
                },
                {
                    field: '(If Yes, please select the nature of Mail)',
                    value:
                        this.customerDetails &&
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.mailNature
                            ? this.customerDetails.accountInfo.mailNature.join(
                                  ', '
                              )
                            : 'N/A',
                },
                {
                    field: 'For All Other Correspondence:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.mailNatureMisc
                            ? this.customerDetails.accountInfo.mailNatureMisc.join(
                                  ', '
                              )
                            : 'N/A',
                }
            )
            this.factaDetails.push(
                {
                    field: 'Title of Account:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.titleOfAcc
                            ? this.customerDetails.fatcaInfo.titleOfAcc
                            : 'N/A',
                },
                {
                    field: 'CNIC No.:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.CNICNumber 
                            ? this.customerDetails.fatcaInfo.CNICNumber
                            : 'N/A',
                },

                {
                    field: 'Country of Residence:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.countryOfResidence
                            ? this.customerDetails.fatcaInfo.countryOfResidence
                            : 'N/A',
                },
                {
                    field: 'Country of Incorporation (For entities):',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.countryOfIncorp
                            ? this.customerDetails.fatcaInfo.countryOfIncorp
                            : 'N/A',
                },

                {
                    field: 'Place of Birth:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.placeOfBirth
                            ? this.customerDetails.fatcaInfo.placeOfBirth
                            : 'N/A',
                },
                {
                    field: 'Are you a US Citizen?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.isUSCitizen &&
                        this.customerDetails.fatcaInfo.isUSCitizen.length
                            ? this.customerDetails.fatcaInfo.isUSCitizen[0]
                            : 'N/A',
                },
                {
                    field: 'Are you a US Resident?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.isUSResident &&
                        this.customerDetails.fatcaInfo.isUSResident.length
                            ? this.customerDetails.fatcaInfo.isUSResident[0]
                            : 'N/A',
                },
                {
                    field: 'Do you hold US Permanent Resident Card (Green Card)?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.greenCardUS &&
                        this.customerDetails.fatcaInfo.greenCardUS.length
                            ? this.customerDetails.fatcaInfo.greenCardUS[0]
                            : 'N/A',
                },

                {
                    field: 'Are you a resident/citizen of any country other than Pakistan?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.CountryResidentOption
                            ? this.customerDetails.fatcaInfo
                                  .CountryResidentOption
                            : 'N/A',
                },
                {
                    field: 'Country of residence other than Pakistan:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.CountryResidentTitle
                            ? this.customerDetails.fatcaInfo
                                  .CountryResidentTitle
                            : 'N/A',
                },
                {
                    field: 'Do you have any tax obligation in a country other than Pakistan?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.CountryTaxOption && 
                        this.customerDetails.fatcaInfo.CountryTaxOption.length
                            ? this.customerDetails.fatcaInfo.CountryTaxOption[0]
                            : 'N/A',
                },
                {
                    field: 'Country of tax obligation other than Pakistan:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.CountryTaxTitle 
                            ? this.customerDetails.fatcaInfo.CountryTaxTitle
                            : 'N/A',
                },
                {
                    field: 'Are you Dual National?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.dualNational 
                            ? this.customerDetails.fatcaInfo.dualNational
                            : 'N/A',
                },
                {
                    field: 'Country of dual nationality:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo
                            .dualNationalCountryTitle 
                            ? this.customerDetails.fatcaInfo
                                  .dualNationalCountryTitle
                            : 'N/A',
                },
                {
                    field: 'Are you a U.S. Owned Entity/ any other country?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.isUSEntity 
                            ? this.customerDetails.fatcaInfo.isUSEntity
                            : 'N/A',
                },
                {
                    field: 'Have you given power of attorney to anyone residing overseas?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.IsPowerAttorney &&
                        this.customerDetails.fatcaInfo.IsPowerAttorney.length
                            ? this.customerDetails.fatcaInfo.IsPowerAttorney[0]
                            : 'N/A',
                },
                {
                    field: "Power of Attorney's Address:",
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.PowerAttorneyAdd 
                            ? this.customerDetails.fatcaInfo.PowerAttorneyAdd
                            : 'N/A',
                },
                {
                    field: 'Fatca Declaraion:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.declaration 
                            ? this.customerDetails.fatcaInfo.declaration[0]
                            : 'N/A',
                }
            )
            this.w9Info.push(
                {
                    field: 'Name (as shown on your income tax return):',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.fullName 
                            ? this.customerDetails.w9Info.fullName
                            : 'N/A',
                },
                {
                    field: 'Business name / disregarded entity name:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.businessName 
                            ? this.customerDetails.w9Info.businessName
                            : 'N/A',
                },
                {
                    field: 'Select appropriate option for federal tax classification:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.federalTax 
                            ? this.customerDetails.w9Info.federalTax
                            : 'N/A',
                },
                {
                    field: 'Exempt Payee Code (if any):',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.payeeCode 
                            ? this.customerDetails.w9Info.payeeCode
                            : 'N/A',
                },
                {
                    field: 'Exemption from FATCA reporting code (if any)',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.fatcaCode 
                            ? this.customerDetails.w9Info.fatcaCode
                            : 'N/A',
                },
                {
                    field: 'Residential Address:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.address
                            ? this.customerDetails.w9Info.address
                            : 'N/A',
                },
                {
                    field: 'City:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.city
                            ? this.customerDetails.w9Info.city
                            : 'N/A',
                },
                {
                    field: 'State:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.state
                            ? this.customerDetails.w9Info.state
                            : 'N/A',
                },
                {
                    field: 'Zip Code:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.zipCode 
                            ? this.customerDetails.w9Info.zipCode
                            : 'N/A',
                },

                {
                    field: 'Taxpayer Identification Number (TIN):',
                    value:
                        this.customerDetails &&
                        this.customerDetails.w9Info &&
                        this.customerDetails.w9Info.tin 
                            ? this.customerDetails.w9Info.tin
                            : 'N/A',
                }
            )
            this.crsDetails.push(
                {
                    field: 'Country of Tax Residence:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsCountryTaxTitle1 
                            ? this.customerDetails.crsInfo.crsCountryTaxTitle1
                            : 'N/A',
                },
                {
                    field: 'TIN or Equivalent:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsTIN1 
                            ? this.customerDetails.crsInfo.crsTIN1
                            : 'N/A',
                },
                {
                    field: 'Reason:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsReason1 
                            ? this.customerDetails.crsInfo.crsReason1
                            : 'N/A',
                },
                {
                    field: 'If reason B selected, please explain why you are unable to obtain a TIN or functional Equivalent:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsOtherReason1 
                            ? this.customerDetails.crsInfo.crsOtherReason1
                            : 'N/A',
                },
                {
                    field: 'Country of Tax Residence #2:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsCountryTaxTitle2 
                            ? this.customerDetails.crsInfo.crsCountryTaxTitle2
                            : 'N/A',
                },
                {
                    field: 'TIN or Equivalent:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsTIN2
                            ? this.customerDetails.crsInfo.crsTIN2
                            : 'N/A',
                },
                {
                    field: 'Reason:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsReason2 
                            ? this.customerDetails.crsInfo.crsReason2
                            : 'N/A',
                },
                {
                    field: 'If reason B selected, please explain why you are unable to obtain a TIN or functional Equivalent:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsOtherReason2 
                            ? this.customerDetails.crsInfo.crsOtherReason2
                            : 'N/A',
                },
                {
                    field: 'Country of Tax Residence #3:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsCountryTaxTitle3 
                            ? this.customerDetails.crsInfo.crsCountryTaxTitle3
                            : 'N/A',
                },
                {
                    field: 'TIN or Equivalent:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsTIN3
                            ? this.customerDetails.crsInfo.crsTIN3
                            : 'N/A',
                },
                {
                    field: 'Reason:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsReason3
                            ? this.customerDetails.crsInfo.crsReason3
                            : 'N/A',
                },

                {
                    field: 'If reason B selected, please explain why you are unable to obtain a TIN or functional Equivalent:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.crsInfo &&
                        this.customerDetails.crsInfo.crsOtherReason3
                            ? this.customerDetails.crsInfo.crsOtherReason3
                            : 'N/A',
                }
            )
            /* check whether dataSegmentId is of SSA Account / RC Account
      // And get Declaration By Customer Fields and
      // Data
      */

            if (!this.isSSAAccount) {
                if (this.customerDetails && this.customerDetails.accountInfo) {
                    this.declarationByCustomer.push(
                        {
                            field: 'Has any Financial Institution ever refused to open your account?',
                            value: this.customerDetails.accountInfo
                                .declarationCustomer1
                                ? this.customerDetails.accountInfo
                                      .declarationCustomer1
                                : 'N/A',
                        },
                        {
                            field: 'Are you opening this Account on behalf of any other person?',
                            value: this.customerDetails.accountInfo
                                .declarationCustomer2
                                ? this.customerDetails.accountInfo
                                      .declarationCustomer2
                                : 'N/A',
                        },
                        {
                            field: 'Are you holding a position in any government/public office?',
                            value: this.customerDetails.accountInfo
                                .declarationCustomer3
                                ? this.customerDetails.accountInfo
                                      .declarationCustomer3
                                : 'N/A',
                        },
                        {
                            field: 'Are you holding a position in any political party?',
                            value: this.customerDetails.accountInfo
                                .declarationCustomer4
                                ? this.customerDetails.accountInfo
                                      .declarationCustomer4
                                : 'N/A',
                        }
                    )
                }
            } // End Declaration By Customer

            /* check whether dataSegmentId is of SSA Account / RC Account
      // And get Transaction Details, pmd, minor account Fields and
      // Data
      */

            if (!this.isSSAAccount) {
                if (this.customerDetails && this.customerDetails.accountInfo) {
                    this.transactionDetails.push(
                        {
                            field: 'Expected No. of Transactions (Monthly)',
                            value: this.customerDetails.accountInfo
                                .expectedTransactions
                                ? this.customerDetails.accountInfo
                                      .expectedTransactions
                                : 'N/A',
                        },
                        {
                            field: 'Annual Income of Client',
                            value: this.customerDetails.accountInfo.grossIncome
                                ? this.customerDetails.accountInfo.grossIncome
                                : 'N/A',
                        },
                        {
                            field: 'Initial Balance',
                            value: this.customerDetails.accountInfo
                                .initialBalance
                                ? this.customerDetails.accountInfo
                                      .initialBalance
                                : 'N/A',
                        },
                        {
                            field: 'Maximum Single Credit Expected In a Month',
                            value: this.customerDetails.accountInfo.creditLimit
                                ? this.customerDetails.accountInfo.creditLimit
                                : 'N/A',
                        },
                        {
                            field: 'Expected Turnover in account (Monthly) PKR',
                            value: this.customerDetails.accountInfo
                                .expectedTurnover
                                ? this.customerDetails.accountInfo
                                      .expectedTurnover
                                : 'N/A',
                        },
                        {
                            field: 'Purpose of Action',
                            value: this.customerDetails.accountInfo
                                .purposeOfActionId
                                ? this.customerDetails.accountInfo
                                      .purposeOfActionId
                                : 'N/A',
                        }
                    )
                    this.minorAccountDetails.push(
                        {
                            field: 'Name of Guardian:',
                            value: this.customerDetails.accountInfo.guardianName
                                ? this.customerDetails.accountInfo.guardianName
                                : 'N/A',
                        },
                        {
                            field: 'Relationship with minor:',
                            value: this.customerDetails.accountInfo
                                .guardianRelationship
                                ? this.customerDetails.accountInfo
                                      .guardianRelationship
                                : 'N/A',
                        },
                        {
                            field: 'Guardian CNIC/NICOP:',
                            value: this.customerDetails.accountInfo.guardianCNIC
                                ? this.customerDetails.accountInfo.guardianCNIC
                                : 'N/A',
                        },
                        {
                            field: 'Guardian ID Issuance Date:',
                            value: this.customerDetails.accountInfo
                                .guardianIssuanceDate
                                ? moment(
                                      this.customerDetails.accountInfo
                                          .guardianIssuanceDate
                                  ).format('MMM D, YYYY')
                                : 'N/A',
                        },
                        {
                            field: 'Guardian ID Expiry Date:',
                            value: this.customerDetails.accountInfo
                                .guardianExpiryDate
                                ? moment(
                                      this.customerDetails.accountInfo
                                          .guardianExpiryDate
                                  ).format('MMM D, YYYY')
                                : 'N/A',
                        },
                        {
                            field: 'Guardian Mobile No.:',
                            value: this.customerDetails.accountInfo
                                .guardianMobileNo
                                ? this.customerDetails.accountInfo
                                      .guardianMobileNo
                                : 'N/A',
                        }
                    )
                }
            }

            if (!this.isSSAAccount) {
                if (this.customerDetails && this.customerDetails.pmd) {
                    this.pmd.push(
                        {
                            field: 'PMD Verification Status',
                            value: this.customerDetails.pmd
                                .pmdVerificationStatus
                                ? this.customerDetails.pmd.pmdVerificationStatus
                                : 'N/A',
                        },
                        {
                            field: 'Relation',
                            value:
                                this.customerDetails.pmd.recievePmdaOption &&
                                this.customerDetails.pmd.recievePmdaOption
                                    .length > 0
                                    ? this.customerDetails.pmd.recievePmdaOption
                                    : 'N/A',
                        }
                    )
                }
            }

            // this.ultimateBenefit.push(
            //     {
            //         field: 'Name of Ultimate Beneficiary:',
            //         value:
            //             this.customerDetails &&
            //             this.customerDetails.accountInfo &&
            //             this.customerDetails.accountInfo.ultimateBenName &&
            //             this.customerDetails.accountInfo.ultimateBenName
            //                 ? this.customerDetails.accountInfo.ultimateBenName
            //                 : 'N/A',
            //     },
            //     {
            //         field: 'Relationship with the Customer:',
            //         value:
            //             this.customerDetails &&
            //             this.customerDetails.accountInfo &&
            //             this.customerDetails.accountInfo.ultimateBenRelation &&
            //             this.customerDetails.accountInfo.ultimateBenRelation
            //                 ? this.customerDetails.accountInfo
            //                       .ultimateBenRelation
            //                 : 'N/A',
            //     },
            //     {
            //         field: 'CNIC/NICOP/Passport No.:',
            //         value:
            //             this.customerDetails &&
            //             this.customerDetails.accountInfo &&
            //             this.customerDetails.accountInfo.ultimateBenIdNo &&
            //             this.customerDetails.accountInfo.ultimateBenIdNo
            //                 ? this.customerDetails.accountInfo.ultimateBenIdNo
            //                 : 'N/A',
            //     }
            // )

            /* check whether dataSegmentId is of SSA Account / RC Account
      // And get Contact Information & residential infoF Fields and
      // Data
      */
            if (this.isSSAAccount) {
                if (this.customerDetails && this.customerDetails.contactInfo) {
                    this.contactInformation.push(
                        {
                            field: 'Residential Address',
                            value: this.customerDetails.contactInfo.address
                                ? this.customerDetails.contactInfo.address
                                : 'N/A',
                        },
                        {
                            field: 'Mailing Address',
                            value: this.customerDetails.contactInfo.address2
                                ? this.customerDetails.contactInfo.address2
                                : 'N/A',
                        },
                        {
                            field: 'State',
                            value: this.customerDetails.contactInfo.state.length
                                ? this.customerDetails.contactInfo.state[0]
                                      .title
                                : 'N/A',
                        },
                        {
                            field: 'City',
                            value: this.customerDetails.contactInfo.city
                                ? this.customerDetails.contactInfo.city
                                : 'N/A',
                        },
                        {
                            field: 'Are you a resident of Pakistan?',
                            value: this.customerDetails.permPakResident
                                ? this.customerDetails.permPakResident
                                : 'N/A',
                        },
                        {
                            field: 'Country of Residence',
                            value: this.customerDetails.countryOfResidence.title
                                ? this.customerDetails.countryOfResidence.title
                                : 'N/A',
                        },
                        {
                            field: 'Do you have other Nationalities',
                            value: this.customerDetails.hasOtherNationalities && this.customerDetails.hasOtherNationalities.length
                                ? this.customerDetails.hasOtherNationalities[0]
                                : 'N/A',
                        },
                        {
                            field: 'Specify other Nationalities',
                            value:
                                this.customerDetails.hasOtherNationalities ==
                                'Yes'
                                    ? this.customerDetails.otherNationalities
                                          .map((e) => e.title)
                                          .join(', ')
                                    : 'N/A',
                        },
                        {
                            field: 'Phone Number',
                            value: this.customerDetails.contactInfo.phoneNumber
                                ? this.customerDetails.contactInfo.isdCode +
                                  ' ' +
                                  this.customerDetails.contactInfo.phoneNumber
                                : 'N/A',
                        },
                        {
                            field: 'Email',
                            value: this.customerDetails.contactInfo.email
                                ? this.customerDetails.contactInfo.email
                                : 'N/A',
                        }
                    )
                }
            } else {
                if (this.customerDetails && this.customerDetails.contactInfo) {
                    this.contactInformation.push(
                        {
                            field: 'Residential Address',
                            value: this.customerDetails.contactInfo.address
                                ? this.customerDetails.contactInfo.address
                                : 'N/A',
                        },
                        {
                            field: 'Mailing Address',
                            value: this.customerDetails.contactInfo.address2
                                ? this.customerDetails.contactInfo.address2
                                : 'N/A',
                        },
                        {
                            field: 'Email',
                            value: this.customerDetails.contactInfo.email
                                ? this.customerDetails.contactInfo.email
                                : 'N/A',
                        },
                        {
                            field: 'Phone Number',
                            value: this.customerDetails.contactInfo.phoneNumber
                                ? this.customerDetails.contactInfo.isdCode +
                                  ' ' +
                                  this.customerDetails.contactInfo.phoneNumber
                                : 'N/A',
                        },
                        {
                            field: 'State',
                            value: this.customerDetails.contactInfo.state.length
                                ? this.customerDetails.contactInfo.state[0]
                                      .title
                                : 'N/A',
                        },
                        {
                            field: 'City',
                            value: this.customerDetails.contactInfo.city
                                ? this.customerDetails.contactInfo.city
                                : 'N/A',
                        },
                        {
                            field: 'Zip Code/Postal Code',
                            value: this.customerDetails.contactInfo.postalCode
                                ? this.customerDetails.contactInfo.postalCode
                                : 'N/A',
                        },
                        {
                            field: 'Tel No. (Res)',
                            value: this.customerDetails.contactInfo.phoneRes
                                ? this.customerDetails.contactInfo.phoneRes
                                : 'N/A',
                        },
                        {
                            field: 'Tel No. (Off)',
                            value: this.customerDetails.contactInfo.phoneOffice
                                ? this.customerDetails.contactInfo.phoneOffice
                                : 'N/A',
                        },
                        {
                            field: 'Fax',
                            value: this.customerDetails.contactInfo.fax
                                ? this.customerDetails.contactInfo.fax
                                : 'N/A',
                        },

                        {
                            field: 'WhatsApp Number',
                            value: this.customerDetails.contactInfo
                                .phoneWhatsApp
                                ? this.customerDetails.contactInfo
                                      .whatsappIsdCode +
                                  ' ' +
                                  this.customerDetails.contactInfo.phoneWhatsApp
                                : 'N/A',
                        }
                    )
                    this.residentialInfo.push(
                        {
                            field: 'Residential Status:',
                            value: this.customerDetails.residentialStatus
                                ? this.customerDetails.residentialStatus
                                : 'N/A',
                        },
                        {
                            field: 'Permanent Resident in Pakistan:',
                            value: this.customerDetails.permPakResident && this.customerDetails.permPakResident.length
                                ? this.customerDetails.permPakResident == 'NICOP' ? 'NICOP' : this.customerDetails.permPakResident[0]
                                : 'N/A',
                        },
                        {
                            field: 'Nationality:',
                            value: this.customerDetails.nationality.title
                                ? this.customerDetails.nationality.title
                                : 'N/A',
                        },
                        {
                            field: 'Country of Residence:',
                            value: this.customerDetails.countryOfResidence.title
                                ? this.customerDetails.countryOfResidence.title
                                : 'N/A',
                        },

                        {
                            field: 'Do you hold US Green Card?',
                            value: this.customerDetails.contactInfo.greenCardUS
                                ? this.customerDetails.contactInfo.greenCardUS
                                : 'N/A',
                        },
                        {
                            field: 'Are you a US Resident?',
                            value: this.customerDetails.contactInfo.residentUS
                                ? this.customerDetails.contactInfo.residentUS
                                : 'N/A',
                        },
                        {
                            field: 'Are you tax resident of Pakistan and/or USA?',
                            value: this.customerDetails.contactInfo.taxResident
                                ? this.customerDetails.contactInfo.taxResident
                                : 'N/A',
                        },
                        {
                            field: 'Do you have other Nationalities?',
                            value: this.customerDetails.hasOtherNationalities && this.customerDetails.hasOtherNationalities.length
                                ? this.customerDetails.hasOtherNationalities[0]
                                : 'N/A',
                        },
                        {
                            field: 'Specify other Nationalities',
                            value:
                                this.customerDetails.hasOtherNationalities ==
                                'Yes'
                                    ? this.customerDetails.otherNationalities
                                          .map((e) => e.title)
                                          .join(', ')
                                    : 'N/A',
                        }
                    )
                }
            }
        },
    }, // End of Component > filters
} // End of export default
</script>
